import { render } from "./newsInformationPage.vue?vue&type=template&id=57f17d50&scoped=true"
import script from "./newsInformationPage.vue?vue&type=script&lang=js"
export * from "./newsInformationPage.vue?vue&type=script&lang=js"

import "./newsInformationPage.vue?vue&type=style&index=0&id=57f17d50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f17d50"]])

export default __exports__